"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomColorPicker = exports.MyPicker = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactColor = require("react-color");

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

var _common = require("react-color/lib/components/common");

var _ChromeFields = _interopRequireDefault(require("react-color/lib/components/chrome/ChromeFields"));

var _SketchPresetColors = _interopRequireDefault(require("react-color/lib/components/sketch/SketchPresetColors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MyPicker = function MyPicker(props) {
  var styles = {
    container: {
      background: 'white',
      border: '1px solid gray'
    },
    saturation: {
      height: 150,
      position: 'relative'
    },
    hue: {
      height: 10,
      position: 'relative'
    },
    details: {
      paddingLeft: 8,
      paddingRight: 8
    },
    fields: {
      paddingBottom: 12,
      borderBottom: '1px solid rgb(238, 238, 238)',
      marginBottom: 10
    },
    input: {
      height: 34,
      border: "1px solid ".concat(props.hex),
      paddingLeft: 10
    },
    swatch: {
      display: 'inline-block',
      width: 54,
      height: 38,
      background: props.hex
    },
    clear: {
      margin: 6,
      cursor: 'pointer'
    },
    presets: {
      marginTop: 8
    }
  };
  var presetColors = ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'];
  return /*#__PURE__*/_react.default.createElement("div", {
    style: styles.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.saturation
  }, /*#__PURE__*/_react.default.createElement(_common.Saturation, _extends({
    pointer: props.showPicker ? undefined : function () {
      return /*#__PURE__*/_react.default.createElement("div", null);
    }
  }, props))), /*#__PURE__*/_react.default.createElement("div", {
    style: styles.hue
  }, /*#__PURE__*/_react.default.createElement(_common.Hue, {
    hsl: props.hsl,
    onChange: props.onChange
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: styles.details
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.fields
  }, /*#__PURE__*/_react.default.createElement(_ChromeFields.default, props)), /*#__PURE__*/_react.default.createElement("div", {
    style: styles.swatch
  }), /*#__PURE__*/_react.default.createElement(_.Icon, {
    icon: "close",
    style: styles.clear,
    onClick: function onClick() {
      return props.onReset();
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: styles.presets
  }, /*#__PURE__*/_react.default.createElement(_SketchPresetColors.default, {
    colors: presetColors,
    onClick: props.onChange // onSwatchHover={ onSwatchHover }

  }))));
};

exports.MyPicker = MyPicker;
var CustomColorPicker = (0, _reactColor.CustomPicker)(MyPicker);
/*---------------------------------------------*/

exports.CustomColorPicker = CustomColorPicker;

var Colorpicker = /*#__PURE__*/function (_Component) {
  _inherits(Colorpicker, _Component);

  var _super = _createSuper(Colorpicker);

  function Colorpicker() {
    var _this;

    _classCallCheck(this, Colorpicker);

    _this = _super.call(this);
    _this.state = {};
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onReset = _this.onReset.bind(_assertThisInitialized(_this));
    _this.onClickOutside = _this.onClickOutside.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Colorpicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onClickOutside);
    }
  }, {
    key: "onClickOutside",
    value: function onClickOutside(event) {
      if (this.ref && !this.ref.current.contains(event.target)) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(color) {
      var value = color ? "rgba(".concat(color.rgb.r, ",").concat(color.rgb.g, ",").concat(color.rgb.b, ",").concat(color.rgb.a, ")") : undefined;
      this.setState({
        value: value
      });
      this.props.onChange && this.props.onChange(value);
    }
  }, {
    key: "onReset",
    value: function onReset() {
      this.onChange(undefined);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      var value = this.props.value || this.state.value;
      var styles = {
        picker: {
          display: this.state.open ? 'block' : 'none'
        },
        icon: {
          background: value
        }
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.getStyle(),
        className: this.getClassNames(),
        tabIndex: "0"
      }, /*#__PURE__*/_react.default.createElement(_.Label, {
        standAlone: true
      }, this.props.label), /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(this.constructor.BASE_CLASS, "--icon"),
        style: styles.icon,
        onClick: function onClick() {
          return _this2.setState({
            open: true
          });
        }
      }, value === undefined ? /*#__PURE__*/_react.default.createElement(_.Icon, {
        icon: "close",
        style: {
          margin: -4
        }
      }) : null), /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(this.constructor.BASE_CLASS, "--picker"),
        style: styles.picker,
        ref: this.ref
      }, /*#__PURE__*/_react.default.createElement(CustomColorPicker, {
        color: value,
        showPicker: !!value,
        onChange: this.onChange,
        onReset: this.onReset
      })));
    }
  }]);

  return Colorpicker;
}(_component.default);
/*---------------------------------------------*/


exports.default = Colorpicker;

_defineProperty(Colorpicker, "BASE_CLASS", 'lth-c-colorpicker');

Colorpicker.METADATA = {
  name: 'Colorpicker',
  props: [{
    name: 'label',
    type: 'string',
    default: 'Enter your input'
  }, {
    name: 'value',
    type: 'string',
    default: ''
  }, {
    name: 'placeholder',
    type: 'string',
    default: 'Enter your input'
  }, {
    name: 'disabled',
    type: 'boolean',
    default: false
  }, {
    name: 'error',
    type: 'boolean',
    default: false
  }, {
    name: 'forcehover',
    type: 'boolean',
    default: false
  }, {
    name: 'forcefocus',
    type: 'boolean',
    default: false
  }, {
    name: 'message',
    type: 'string'
  }, {
    name: 'onChange',
    type: 'function'
  }]
};